import type { Theme } from 'config/theme/types';

import { zdfColorsDark } from './zdf-color-dark';
import { zdfColorsLight } from './zdf-color-light';
import { zdfFontFamilies } from './zdf-font-families';
import { zdfKikaAvatarColors, zdfKikaColors } from './zdf-kika-color.ts';
import { zdfLogoColors } from './zdf-logo-color.ts';
import { zdfStreamingPortalColors } from './zdf-streaming-portal-colors.ts';

export const zdfThemeNames = ['zdf', 'zdfHeuteDark', 'zdfHeuteLight', 'zdfKika', 'zdfStreamingPortal', 'zdfLogo'] as const;
export type ZdfThemeName = (typeof zdfThemeNames)[number];

const loadZdfFonts = async () => {
    try {
        const fontModule = await import('./zdf-font.ts');
        await fontModule.getZdfFonts();
    } catch {
        console.error('Loading custom fonts failed');
    }
};

const loadKikaFonts = async () => {
    try {
        const fontModule = await import('./zdf-font.ts');
        await fontModule.getKikaFonts();
    } catch {
        console.error('Loading custom fonts failed');
    }
};

export const zdfThemes: Record<ZdfThemeName, Theme> = {
    zdf: {
        colors: zdfColorsDark,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts,
    },
    zdfHeuteDark: {
        colors: zdfColorsDark,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts,
    },
    zdfHeuteLight: {
        colors: zdfColorsLight,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts,
    },
    zdfKika: {
        colors: zdfKikaColors,
        avatarColors: zdfKikaAvatarColors,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadKikaFonts,
    },
    zdfStreamingPortal: {
        colors: zdfStreamingPortalColors,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts,
    },
    zdfLogo: {
        colors: zdfLogoColors,
        fontFamilies: zdfFontFamilies,
        fontLoader: loadZdfFonts,
    },
};
